export const appSettings = {
  serverBaseUrl: process.env.REACT_APP_SERVER_BASE_URL,
  emailjsServiceId: process.env.REACT_APP_EMAILJS_SERVICE_ID,
  emailjsTemplateId: process.env.REACT_APP_EMAILJS_TEMPLATE_ID,
  emailjsPublicKey: process.env.REACT_APP_EMAILJS_PUBLIC_KEY,

  fbEmbeddedVersion: "v22.0",
  facebookAppId: process.env.REACT_APP_FACEBOOK_APP_ID,
  facebookConfigId: process.env.REACT_APP_FACEBOOK_CONFIG_ID,

  mapsKey: "",
};

export const aboutApp = {
  website: "https://wabm.in",
  version: "Copyright © WaBM 2025 | Version: 4.10.1",
  myLinksBaseUrl: "https://mylinks.wabm.in",
};

export const wabaAcceptedInputTypes = {
  image: "image/png, image/jpeg",
  video: "video/mp4, video/3gp",
  audio: "audio/aac, audio/mpeg, audio/mp4, audio/amr, audio/ogg",
  document:
    "text/plain, application/pdf, application/vnd.ms-powerpoint, application/msword, application/vnd.ms-excel, application/vnd.openxmlformats-officedocument.wordprocessingml.document, application/vnd.openxmlformats-officedocument.presentationml.presentation, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  sticker: "image/webp",
};

export const uploadLimits = {
  image: 5 * 1024 * 1024, // 5 megabytes in bytes
  video: 16 * 1024 * 1024, // 16 megabytes in bytes
  audio: 16 * 1024 * 1024, // 16 megabytes in bytes
  document: 100 * 1024 * 1024, // 100 megabytes in bytes
};

export const chatRefreshTime = {
  chatContacts: "5000",
  chatMessages: "5000",
};

export const contactLinks = {
  facebook: "https://www.facebook.com/wabm.in",
  facebookUsername: "@wabm_in",
  instagram: "https://www.instagram.com/wabm.in",
  instagramUsername: "@wabm.in",
  linkedin: "https://www.linkedin.com/showcase/wabm",
  linkedinUsername: "/showcase/wabm",

  salesWhatsapp: "https://api.whatsapp.com/send?phone=919718665000",
  supportWhatsapp: "https://api.whatsapp.com/send?phone=919718665000",

  salesMail: "hi@wabm.in",
  supportMail: "support@wabm.in",
};

export const contactUploadConfig = {
  maximumUploadContact: 30000,
  maximumUploadError: 100,
  defaultCountyCode: 91,
};

export const updateDatabaseFields = [
  { fieldName: "WhatsApp Opt-in", type: "Boolean", dbField: "waOptIn_ti" },
  { fieldName: "Remarks", type: "String", dbField: "remarks_c" },
  { fieldName: "City", type: "String", dbField: "city_c" },
  { fieldName: "Country", type: "String", dbField: "country_c" },
];
